import { Routes } from '@angular/router';
import { BadUrlComponent } from './bad-url/bad-url.component';
import { FeaturesComponent } from './features/features.component';
import { HomeComponent } from './home/home.component';
import { LicenseComponent } from './license/license.component';
import { QuickStartComponent } from './quick-start/quick-start.component';
import { ChangelogComponent } from './changelog/changelog.component';
var ɵ0 = {
    description: 'RON (Rusty Object Notation) language plugin for IntelliJ Idea, Clion, and other Jetbrains IDEs.  IntelliJ RON Plugin.',
    title: 'IntelliJ-RON Plugin'
}, ɵ1 = {
    description: 'IntelliJ-RON plugin license',
    title: 'RON Plugin License'
}, ɵ2 = {
    description: 'IntelliJ-RON (Rusty Object Notation) plugin features, keyboard shortcuts, and examples.',
    title: 'Features'
}, ɵ3 = {
    description: 'Getting started guide for using the RON (Rusty Object Notation) plugin with IntelliJ Idea.',
    title: 'Quick Start'
}, ɵ4 = {
    description: 'RON (Rusty Object Notation) plugin for IntelliJ Idea changelog, bug fixes, and releases.',
    title: 'Changelog'
}, ɵ5 = {
    description: '404 Page Not Found',
    title: '404 Page Not Found'
};
// Reminder: When adding / changing routes, add them to /prerenderer/prerenderer.ts and app.component.ts
var routes = [
    {
        path: '', pathMatch: 'full', component: HomeComponent, data: ɵ0
    },
    {
        path: 'license', component: LicenseComponent, data: ɵ1
    },
    {
        path: 'features', component: FeaturesComponent, data: ɵ2
    },
    {
        path: 'quickstart', component: QuickStartComponent, data: ɵ3
    },
    {
        path: 'changelog', component: ChangelogComponent, data: ɵ4
    },
    {
        path: '404', component: BadUrlComponent, data: ɵ5
    },
    { path: '**', redirectTo: '/404' }
];
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5 };
